/* PDP v3 – scroll-reveal animations (fade/slide in as sections enter view) */
(function () {
  if (window.__pdp3Reveal) return; window.__pdp3Reveal = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var groups = [
    // [selector, variant, stagger ms]
    ['.pdp3-benefits .pdp3-h2, .pdp3-ings .pdp3-h2, .pdp3-reviews .pdp3-h2, .pdp3-faq .pdp3-h2, .pdp3-faq .pdp3-intro, .pdp3-reviews__sum', '', 0],
    ['.pdp3-benefit', '', 80],
    ['.pdp3-descr .pdp3-c', '', 0],
    ['.pdp3-ings__banner', 'zoom', 0],
    ['.pdp3-ings__col--left .pdp3-ing', 'left', 120],
    ['.pdp3-ings__col--right .pdp3-ing', 'right', 120],
    ['.pdp3-why .pdp3-h3', '', 0],
    ['.pdp3-why__list li', '', 70],
    ['.pdp3-why__media', 'right', 0],
    ['.pdp3-howto .pdp3-h2', '', 0],
    ['.pdp3-step', 'left', 110],
    ['.pdp3-howto__media', 'right', 0],
    ['.pdp3-reviews__wrap, .pdp3-reviews__cta', '', 0],
    ['.pdp3-faq__item', '', 60],
    ['.pdp3-content__inner > *', '', 110],
    ['.pdp3-videos .pdp3-h2, .pdp3-videos .pdp3-intro', '', 0],
    ['.pdp3-video', '', 90]
  ];
  function init() {
    var els = [];
    groups.forEach(function (g) {
      var list = document.querySelectorAll(g[0]);
      list.forEach(function (el, i) {
        if (el.classList.contains('pdp3-rv')) return;
        el.classList.add('pdp3-rv');
        if (g[1]) el.classList.add('pdp3-rv--' + g[1]);
        if (g[2]) el.style.setProperty('--rv-d', Math.min(i * g[2], 600) + 'ms');
        els.push(el);
      });
    });
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* PDP v3 – smooth FAQ accordion (animates height open/close) */
(function () {
  if (window.__pdp3Faq) return; window.__pdp3Faq = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.25,.8,.25,1)', DUR = 380;
  function animate(d, opening) {
    var a = d.querySelector('.pdp3-faq__a'); if (!a) return;
    if (d._anim) d._anim.cancel();
    if (reduce || !a.animate) { d.open = opening; return; }
    if (opening) { d.open = true; }
    var h = a.scrollHeight;
    d.classList.toggle('is-opening', opening);
    d.classList.toggle('is-closing', !opening);
    var cs = getComputedStyle(a), pt = cs.paddingTop, pb = cs.paddingBottom;
    var shut = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0, transform: 'translateY(-6px)' };
    var full = { height: h + 'px', paddingTop: pt, paddingBottom: pb, opacity: 1, transform: 'none' };
    var frames = opening ? [shut, full] : [full, shut];
    a.style.overflow = 'hidden';
    d._anim = a.animate(frames, { duration: DUR, easing: EASE });
    d._anim.onfinish = function () {
      if (!opening) d.open = false;
      a.style.overflow = ''; d._anim = null;
      d.classList.remove('is-opening', 'is-closing');
    };
    d._anim.oncancel = function () { a.style.overflow = ''; };
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.pdp3-faq__item > summary'); if (!s) return;
    e.preventDefault();
    var d = s.parentElement;
    var opening = !d.open || d.classList.contains('is-closing');
    animate(d, opening);
  });
})();
